import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { AuthService } from './service/auth.service'; // Adjust path if needed

export const AuthGuard: CanActivateFn = (route, state) => {
  const authService = inject(AuthService);
    const router = inject(Router);

  if (authService.isLoggedIn()) {
      return true;
        }

  router.navigate(['/login']);
    return false;
    };
